import { useUpdateUserIntegrationModal } from "@/features/update-user-integration"
import { useAppDispatch } from "@/shared/lib/redux"
import { fetchUserIntegration } from "../../model"

export const CreateIntegration = () => {
    const { openCreateUserIntegrationModal } = useUpdateUserIntegrationModal()
    const dispatch = useAppDispatch()
    
    const onCreate = () => {
        dispatch(fetchUserIntegration())
    }

    return (
        <button onClick={() => openCreateUserIntegrationModal(onCreate)} className="py-[9px] w-fit px-6 rounded-full font-medium leading-[30px] bg-color-dark text-white">
            Добавить пользовательскую интеграцию
        </button>
    )
}